import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { FC } from "react";
import Lottie from "react-lottie";
import { useLocation, useNavigate } from "react-router-dom";
import theme from "theme";
import PaymentSuccess from "../../../../src/images/PaymentSuccess.json";
import {
    PaymentContent,
    PricingHeader,
    PricingWrapper,
} from "../Pricing.styled";

export const Success: FC = () => {
    const navigateTo = useNavigate();
    const location = useLocation();
    const PlanRedirectionLink = () => {
        navigateTo(
            routeConstants.settings.root + routeConstants.settings.plans
        );
    };

    const defaultOptions = {
        loop: true,
        autoplay: true,
        speed: 0.0025,
        animationData: PaymentSuccess,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };
    return (
        <PricingWrapper>
            <PricingHeader>
                <Grid
                    column={true}
                    direction="column-direction"
                    rowGap={1}
                    style={{ alignItems: "center" }}
                >
                    <Text
                        variant="heading2"
                        fontWeight="800"
                        color={theme.colors.grey.dark}
                    >
                        Simple, Transparent{" "}
                        <Text
                            variant="heading2"
                            color={theme.colors.purple.primary}
                            fontWeight="800"
                        >
                            Pricing
                        </Text>
                    </Text>
                    {/* <Text
                        variant="label"
                        fontWeight="500"
                        color={theme.colors.grey.secondary}
                    >
                        Invest In Your Modeling Career
                    </Text> */}
                </Grid>
            </PricingHeader>
            <PaymentContent>
                <Lottie options={defaultOptions} height={300} width={300} />
                <Text
                    variant="body1"
                    color={theme.colors.purple.primary}
                    fontWeight="800"
                    fontSize="36px"
                >
                    Thank You!
                </Text>
                {!location.pathname.includes("purchase") && (
                    <>
                        <Text
                            variant="heading3"
                            color={theme.colors.purple.primary}
                        >
                            Your job has been successfully posted!
                        </Text>
                        <Text variant="body3">
                            Redirect to{" "}
                            <Text
                                onClick={() => {
                                    navigateTo(
                                        routeConstants.jobs.listings.root +
                                            "/" +
                                            routeConstants.jobs.listings.active
                                    );
                                }}
                                variant="body3"
                                style={{
                                    color: "rgb(136, 104, 234)",
                                    cursor: "pointer",
                                }}
                            >
                                My Casting
                            </Text>{" "}
                            to view your current job
                        </Text>
                    </>
                )}
                {location.pathname.includes("purchase") && (
                    <>
                        <Text
                            variant="heading3"
                            color={theme.colors.purple.primary}
                        >
                            Your plan has been successfully subscribed!
                        </Text>
                        <Text variant="body3">
                            Redirect to{" "}
                            <Text
                                onClick={PlanRedirectionLink}
                                variant="body3"
                                style={{
                                    color: "rgb(136, 104, 234)",
                                    cursor: "pointer",
                                }}
                            >
                                My Plans
                            </Text>{" "}
                            to view your current plan
                        </Text>
                    </>
                )}
            </PaymentContent>
        </PricingWrapper>
    );
};
